import {RemotePostContent} from 'data/usecases/private/content/remote-post-content';
import {PostContent} from 'domain/usecases/private/content/post-content';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {ContentEndpoints} from '../../endpoints';

export const makePostContent = (): PostContent =>
	new RemotePostContent(
		makeBFFApiUrl(ContentEndpoints.content),
		makeAuthorizeHttpClientDecorator(),
	);
